import { Contact2, EarthIcon, Globe, LogOut, ScrollText, Shield } from 'lucide-react';
import { Button, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuLabel, DropdownMenuGroup, toast } from '@cuspar/ui';
import { useAuthStore } from '../../state/authStore';
import { Link, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '../../routes';
import { UserRole } from '@cuspar/ywt.ch.model';
import { AvartarDisplay } from '../Account/Avartar';

export function AuthStatusHeader() {
  const { t } = useTranslation();
  const { user, signOut } = useAuthStore();

  const navigate = useNavigate();

  function goToAccount() {
    navigate(ROUTES.account.profile);
  }
  function goToDomain() {
    navigate(ROUTES.account.domains);
  }
  function goToOrder() {
    navigate(ROUTES.account.orders);
  }
  function goToAdmin() {
    navigate(ROUTES.admin.root);
  }
  function goToWebsite() {
    navigate(ROUTES.account.websites);
  }
  function logout() {
    signOut();
    toast.success(t('auth.loggedOut'));
    navigate(ROUTES.home);
  }

  if (!user)
    return (
      <Link to={ROUTES.auth.signin}>
        <Button variant='outline'>{t('auth.signIn')}</Button>
      </Link>
    );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant='ghost' size='icon' data-testid='account-menu-trigger'>
          <AvartarDisplay user={user} />
          <span className='sr-only'>{user.email}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end' className='w-56'>
        <DropdownMenuLabel>{t('account.myAccount')}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem onClick={goToAccount}>
            <Contact2 className='mr-2 h-4 w-4' />
            {t('account.account')}
          </DropdownMenuItem>
          <DropdownMenuItem onClick={goToOrder}>
            <ScrollText className='mr-2 h-4 w-4' />
            {t('account.orders')}
          </DropdownMenuItem>
          <DropdownMenuItem onClick={goToDomain}>
            <EarthIcon className='mr-2 h-4 w-4' />
            {t('account.domains')}
          </DropdownMenuItem>

          <DropdownMenuItem onClick={goToWebsite}>
            <Globe className='mr-2 h-4 w-4' />
            {t('account.websiteHosting')}
          </DropdownMenuItem>
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={logout} data-testid='account-menu-logout'>
          <LogOut className='mr-2 h-4 w-4' />
          {t('account.logOut')}
        </DropdownMenuItem>
        {user.role === UserRole.ADMIN && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={goToAdmin}>
              <Shield className='mr-2 h-4 w-4' />
              {t('account.admin')}
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
